import { useEffect, useState } from "react";

/* useIsMobile — viewport < 768 OR PWA running standalone on small screen.
 * Exposed as a reactive boolean so tablet rotation works live.
 */
export default function useIsMobile(breakpoint = 768) {
  const [isMobile, setIsMobile] = useState(() =>
    typeof window !== "undefined" &&
    (window.innerWidth < breakpoint ||
      (window.matchMedia?.("(display-mode: standalone)")?.matches &&
        window.innerWidth < 900))
  );
  useEffect(() => {
    const check = () =>
      window.innerWidth < breakpoint ||
      (window.matchMedia?.("(display-mode: standalone)")?.matches &&
        window.innerWidth < 900);
    const onResize = () => setIsMobile(check());
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, [breakpoint]);
  return isMobile;
}

/* Small haptic helper — vibration where supported, silent fallback elsewhere. */
export function haptic(pattern = 35) {
  try {
    navigator.vibrate?.(pattern);
  } catch {}
}
